import React from 'react'

import photo from 'assets/images/compliancePage/ivanov@2x.jpg'

import classes from './Quote.module.scss'

export const Quote: React.FC = () => {
  return (
    <div className={`row row_overflow ${classes.row}`}>
      <div className="col-xs-12">
        <h1 className="title uppercase">
          Комплаенс и <br /> деловая этика
        </h1>
      </div>

      <div className="col-xl-7 col-lg-8 col-md-7 col-sm-8 col-xs-12">
        <img className={classes.img} src={photo} alt="Игорь Мишин" />

        <blockquote className={classes.quote}>
          <div className={classes.quote__title}>Дорогие друзья!</div>
          <div className={classes.quote__text}>
            <p>
              Этика ведения бизнеса является неотъемлемой частью стратегии
              развития KION. Мы придерживаемся высочайших этических стандартов и
              стандартов и постоянно совершенствуемся. Все работники и менеджеры
              нашей компании соблюдают этические принципы, правила и законы не
              под давлением или из страха быть наказанными, а потому что так
              поступать правильно, честно и этого от нас ожидают партнеры,
              коллеги и общество
            </p>
            <p className={classes.hidden_md}>
              В KION внедрены документы, которые устанавливают стандарты по
              ключевым юридическим, моральным и этическим вопросам, таким как
              противодействие коррупции, соблюдение прав человека, равенство,
              управление конфликтами интересов, защита конфиденциальной
              информации и персональных данных, и являются обязательными для
              членов Совета директоров и всех сотрудников независимо от
              занимаемой должности
            </p>
            <p className={classes.hidden_md}>
              Мы стремимся к лидерству в бизнесе в полном соответствии с
              моральными и этическими нормами, принятыми в нашей Компании и в
              обществе.
            </p>
            <figcaption className="mt-1">
              <h3>Иванов Алексей</h3>
              <small>
                Генеральный директор <span>онлайн-кинотеатра KION</span>
              </small>
            </figcaption>
          </div>
        </blockquote>
      </div>

      <div className="col-xl-5 col-lg-4 col-md-5 col-sm-4 col-xs-12">
        <figure className={classes.figure}>
          <img className={classes.img} src={photo} alt="Иванов Алексей" />
        </figure>
      </div>
    </div>
  )
}
